const category = 'Partner';

export default Object.freeze({
  ACCOUNTABLE: Object.freeze({
    INFO: Object.freeze({
      category,
      action: 'Accountable',
      label: 'More information'
    })
  }),
  CREDITPLACE: Object.freeze({
    INFO: Object.freeze({
      category,
      action: 'CreditPlace',
      label: 'More information'
    })
  }),
  GOLEGAL: Object.freeze({
    INFO: Object.freeze({
      category,
      action: 'GoLegal',
      label: 'More information'
    })
  }),
  OPENWORK: Object.freeze({
    OPT_IN: Object.freeze({
      category,
      action: 'OpenWork',
      label: 'Opt-in confirm'
    }),
    OPT_IN_MODAL: Object.freeze({
      category,
      action: 'OpenWork',
      label: 'Opt-in modal'
    }),
    INFO: Object.freeze({
      category,
      action: 'OpenWork',
      label: 'More information'
    })
  }),
  SECUREX: Object.freeze({
    OPT_IN: Object.freeze({
      category,
      action: 'Securex',
      label: 'Opt-in'
    }),
    INFO: Object.freeze({
      category,
      action: 'Securex',
      label: 'More information'
    })
  }),
  SKIPR: Object.freeze({
    INFO: Object.freeze({
      category,
      action: 'Skipr',
      label: 'More information'
    })
  }),
  ULAW: Object.freeze({
    INFO: Object.freeze({
      category,
      action: 'uLaw',
      label: 'More information'
    })
  }),
  SILVERSQUARE: Object.freeze({
    INFO: Object.freeze({
      category,
      action: 'Silversquare',
      label: 'More information'
    })
  }),
  TWINNTAX: Object.freeze({
    INFO: Object.freeze({
      category,
      action: 'TwinnTax',
      label: 'More information'
    })
  })
});
